import { Helmet } from 'react-helmet'
import { graphql, useStaticQuery, withPrefix } from 'gatsby'
import * as React from 'react'

import { SiteMetadataQuery } from '../../../types/graphql-types.d'

type Props = {
  lang?: string
  meta?: Helmet['meta']
  title?: string
  description?: string
  suffix?: string
  ogpType?: string
  sharePath?: string
  shareImage?: string
}

const SEO: React.FC<Props> = ({ description, meta, title, suffix, ogpType, sharePath, shareImage }) => {
  const { site } = useStaticQuery<SiteMetadataQuery>(
    graphql`
      query SiteMetadata {
        site {
          siteMetadata {
            title
            description
            siteUrl
            keyword
          }
        }
      }
    `,
  )

  const metadata = site?.siteMetadata
  const baseTitle = metadata?.title ?? ''
  const baseDescription = metadata?.description ?? ''
  const baseSiteUrl = metadata?.siteUrl ?? ''

  const metaTitleSuffix = suffix !== undefined ? (suffix === '' ? '' : ` | ${suffix}`) : ` | ${baseTitle}`
  const metaTitle = title ? `${title}${metaTitleSuffix}` : baseTitle
  const metaUrl = sharePath ? `${baseSiteUrl}${withPrefix(sharePath)}` : `${baseSiteUrl}`
  const metaDescription = description || baseDescription
  const metaOgpType = ogpType || 'website'
  const metaShareImage = shareImage ? `${baseSiteUrl}/${withPrefix(shareImage)}` : `${baseSiteUrl}/images/ogimage.png`
  const keyword = metadata?.keyword ?? ''

  return (
    <Helmet
      htmlAttributes={{
        lang: 'ja',
      }}
      title={metaTitle}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },

        {
          property: 'og:title',
          content: metaTitle,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:url',
          content: metaUrl,
        },
        {
          property: 'og:image',
          content: metaShareImage,
        },
        {
          property: 'og:type',
          content: metaOgpType,
        },
        {
          property: 'og:site_name',
          content: baseTitle,
        },
        {
          name: 'twitter:title',
          content: 'Asia Young Designer Awards | Nippon Paint',
        },
        {
          name: 'twitter:description',
          content:
            'The Asia Young Designer Awards aims to nurture young design talents across Asia by setting a platform for them to share design ideas with professionals.',
        },
        {
          name: 'twitter:image',
          content: metaShareImage,
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'keyword',
          content: keyword,
        },
      ].concat(meta || [])}
    >
      <script
        type="text/javascript"
        src="//typesquare.com/3/tsst/script/ja/typesquare.js?5YYAC0xT8Kg%3D&auto_load_font=true"
        charset="utf-8"
      ></script>
    </Helmet>
  )
}

export default SEO
